<template>
  <div class="confirm-overlay" @click.self="$emit('cancel')">
    <div class="confirm-dialog" role="dialog" aria-modal="true">
      <p class="confirm-title">{{ title }}</p>
      <p class="confirm-body">{{ body }}</p>
      <div class="confirm-actions">
        <button class="confirm-btn cancel" @click="$emit('cancel')">{{ cancelLabel }}</button>
        <button class="confirm-btn danger" @click="$emit('confirm')">{{ confirmLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  emits: ['confirm', 'cancel'],
  props: {
    title: { type: String, required: true },
    body: { type: String, default: '' },
    confirmLabel: { type: String, default: 'Bevestigen' },
    cancelLabel: { type: String, default: 'Annuleren' }
  }
}
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 100;
}

.confirm-dialog {
  background: #fff;
  border-radius: 12px;
  padding: 1.75rem;
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.confirm-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2c3e50;
}

.confirm-body {
  font-size: 0.95rem;
  color: #555;
}

.confirm-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.confirm-btn {
  flex: 1;
  padding: 0.85rem;
  font-size: 1rem;
  font-family: inherit;
  border-radius: 8px;
  cursor: pointer;
  touch-action: manipulation;
  border: none;
}

.confirm-btn.cancel {
  background: transparent;
  color: #2c3e50;
  border: 2px solid #2c3e50;
}

.confirm-btn.danger {
  background-color: #c0392b;
  color: #fff;
}

.confirm-btn:active {
  opacity: 0.75;
}
</style>
